<template>
	<div class="btn btn-block btn-lg btn-primary" @click="buyProduct" :disabled="!canBuy" :class="{'disabled': !canBuy}">
		Comprar 
	</div>
</template>

<script>
import ecommerceMixins from './mixins'

export default {
	name: 'BuyButton',
	mixims: [ecommerceMixins],
	props: {
		product: {
			required: true,
		},
		variant:{
			required: false,
		}
	},
	data() {
		return {
			qty: 1,
		}
	},
	computed:{
		canBuy(){
			if(this.product.priceWithoutTaxes <=0 ) return false
			const variants = this.product.variants.filter(variant => variant.hasStock)
			// si el producto madre esta marcado sin stock, no habilito ninguna variante
			if(!this.product.hasStock) return false
			// si el producto tiene variantes CON STOCK, tiene que seleccionar una
			if(variants.length>0 && !this.variant) return false
				
			return true
		},
	},
	methods: {
		buyProduct() {
			const variants = this.product.variants.filter(variant => variant.hasStock)
			if(variants.length>0){
				// si el producto tiene variantes CON STOCK, tiene que seleccionar una
				if(!this.variant){
					this.$toast.error('Debe seleccionar una opción')
					return
				}
			}
			if(this.canBuy){
				this.addToCart(this.product, this.qty, this.variant)
			}

		},
	},
}
</script>
<style scoped>
.btn.disabled{
	background-color: #3a78c970;
	border-color: #3a78c970;
}
</style>
